
export const NOTIFICATION_GROUPS = "[NOTIFICATION_GROUPS]";
export const SET_NOTIFICATION_GROUP = `${NOTIFICATION_GROUPS} Set`;
export const ADD_NOTIFICATION_GROUP = `${NOTIFICATION_GROUPS} Add`;
export const REMOVE_NOTIFICATION_GROUP = `${NOTIFICATION_GROUPS} Delete`;

export const setNotificationGroups = (groups) => ({
    type: SET_NOTIFICATION_GROUP,
    payload: {
        data: groups
    }
});

export const addNotificationGroup = (group) => ({
    type: ADD_NOTIFICATION_GROUP,
    payload: {
        data: group
    }
});

export const removeNotificationGroup = (group) => ({
    type: REMOVE_NOTIFICATION_GROUP,
    payload: {
        data: group
    }
});
